import { ClientService } from "@/services/client/ClientService";

export var clientService = new ClientService();
